(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDeleteController',QueueTypeDeleteController);

    QueueTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'QueueType'];

    function QueueTypeDeleteController($uibModalInstance, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QueueType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
